import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import RoomTypesTable from './RoomTypesTable';
import { Link } from 'react-router-dom';

const RoomTypes = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Room types" title="Room types" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Rooms types</H5>
                <Link to="/room-types/new">
                  <Btn color="primary">New Room Type</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <RoomTypesTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RoomTypes;
